export const globalStorage = {
  // Set data in the window object
  setItem(key, value) {
    window[key] = value;
  },

  // Get data from the window object
  getItem(key) {
    return window[key];
  },

  // Remove data from the window object
  removeItem(key) {
    delete window[key];
  }
};
